/**
 * scrolls to the given element
 *
 * @param target DomElement
 */
export default function (target) {
    const jQueryTarget = jQuery(target);
    const offset = jQueryTarget.offset();
    if (!offset) {
        return; // this id doesn't exist
    }
    if (jQueryTarget.hasClass('invisible')) {
        return; // this is only for screen readers, don't try to scroll
    }
    const fixedHeaderSpacing = jQuery('body').width() < 767 ? 0 : jQuery('header').outerHeight();
    const scrollTop = offset.top - fixedHeaderSpacing;

    // we want to create a consistent scroll speed
    const scrollEl = jQuery('html,body');
    const distance = Math.abs(scrollEl.scrollTop() - scrollTop);
    const time = Math.min(distance * 0.7, 1000);
    scrollEl.animate({scrollTop: scrollTop}, time);

    // update the has
    if (window.history && history.pushState) {
        const id = jQueryTarget.attr('id');
        history.pushState(null, null, location.pathname + (id ? '#' + id : ''));
    }
};
